// extracted by mini-css-extract-plugin
export default {"react-tabs":"styles_react-tabs__l5FCq","react-tabs__tab-list":"styles_react-tabs__tab-list__04q1z","react-tabs__tab--selected":"styles_react-tabs__tab--selected__oB9ZD"};